// components/ReconciliationApprovalDialog.js
import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Box,
} from "@mui/material";
import { PrimaryButton } from "components/Buttons";
import Colors from "assets/Style/Colors";
import { FontFamily } from "assets";

export default function ApprovalReconciliationDialog({ open, onClose, onConfirm }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontWeight: "bold", textAlign: "center", mt:1 }}>
        Reconciliation Approval
      </DialogTitle>
      <DialogContent>
        <Typography px={1} fontSize={18} align="left"fontFamily={FontFamily.NunitoRegular}>
          Do you want to accept approval request to edit the already reconciliated list?
        </Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center", pb: 3 }}>
        <Box sx={{py:1.3, px:7.5, backgroundColor: Colors.iron, borderRadius:2, color :"rgba(0, 0, 0, 0.4)"}}  onClick={onClose}>
          No
        </Box>
        {/* <PrimaryButton title="No" onClick={onClose} style={{ backgroundColor: Colors.iron  }}
 /> */}
        <PrimaryButton title="Yes" onClick={onConfirm}/>
      </DialogActions>
    </Dialog>
  );
}
